<template>
  <v-container style="max-width: 95% !important;">
    <v-alert-dialog
      ref="alert"
    >
    </v-alert-dialog>

    <v-dialog
      max-width="65%"
      v-model="dialogAddEdit"
      persistent
    >
      <v-card>
        <v-card-title>
          {{ editedItem.id_paciente === -1 ? "Crear" : "Editar" }} Paciente
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
                outlined
                :error="errores.nombre"
                :error-messages="errores.nombre ? 'El nombre del paciente debe tener entre 1 y 256 caracteres.' : null"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogAddEdit">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAddEdit" :loading="loadingSave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      max-width="65%"
      v-model="dialogDelete"
      persistent
    >
      <v-card>
        <v-card-title>
          Eliminar Paciente
        </v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar al paciente "{{ editedItem.nombre }}"? Esta acción es permanente y no se puede revertir.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="3">
        <v-text-field
          v-model.lazy="nombreSearch"
          label="Nombre"
          clearable
          dense
          hide-details
          outlined
        ></v-text-field>
      </v-col>
      
      <v-col cols="3">
        <v-text-field
          v-model.lazy="apellidoPaternoSearch"
          label="Apellido Paterno"
          clearable
          dense
          hide-details
          outlined
        ></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-text-field
          v-model.lazy="apellidoMaternoSearch"
          label="Apellido Materno"
          clearable
          dense
          hide-details
          outlined
        ></v-text-field>
      </v-col>

      <v-col cols="3">
        <v-text-field
          v-model.lazy="folioSearch"
          label="Folio"
          clearable
          dense
          hide-details
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-autocomplete
          v-model="servicioSearch"
          label="Servicio"
          clearable
          :items="servicios"
          item-value="id_servicio"
          item-text="nombre"
          dense
          hide-details
          outlined
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="6">
        Rango de Fechas: 
        <date-picker v-model="rangoSearch" range valueType="format" format="DD-MM-YYYY" @change="getItems"></date-picker>
      </v-col>
    </v-row>

    <v-row style="max-width: 1800px !important;">
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :server-items-length="totalRecords"
          @update:page="getItems"
          @update:items-per-page="onItemsPerPageChange"
          :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
        >
          <template v-slot:[`item.genero`]="{ item }">
            {{item.genero ? "M" : "F"}}
          </template>
          <template v-slot:[`item.curp`]="{ item }">
            {{item.curp == null ? "N/A" : item.curp}}
          </template>
          <template v-slot:[`item.seguro_popular`]="{ item }">
            {{item.seguro_popular ? "Sí" : "No"}}
          </template>
          <template v-slot:[`item.num_poliza`]="{ item }">
            {{item.num_poliza == null ? "N/A" : item.num_poliza}}
          </template>
          <template v-slot:[`item.telefono`]="{ item }">
            {{item.telefono == null ? "N/A" : item.telefono}}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <!--
            <v-icon
              small
              class="mr-2"
              @click="openDialogAddEdit(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              small
              class="mr-2"
              @click="openDialogDelete(item)"
            >
              mdi-delete
            </v-icon>
            -->
            <v-icon
              small
              class="mr-2"
              @click="openDialogExpediente(item)"
            >
              mdi-newspaper-variant-outline
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <expediente
      ref="expediente"
    >
    </expediente>
  </v-container>
</template>

<script>
import axios from 'axios'
import _ from 'lodash';
import Expediente from '@/components/DashViews/Expediente.vue'
import VAlertDialog from '@/components/VAlertDialog.vue'
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';


export default {
  components: {
    Expediente,
    VAlertDialog,
    DatePicker
  },
  computed: {
    ...mapState(['token'])
  },
  data: () => ({
    dialogAddEdit: false,
    loading: false,
    items: [],
    page: 1,
    itemsPerPage: 10,
    totalRecords: 0,
    headers:[
      {
        text: "Folio paciente",
        value: "folio",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Nombre",
        value: "nombre",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Apellido Paterno",
        value: "apellido_paterno",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Apellido Materno",
        value: "apellido_materno",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Fecha de Nacimiento",
        value: "fecha_nacimiento",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Edad",
        value: "edad",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Sexo",
        value: "genero",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Estado",
        value: "estado",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Municipio",
        value: "municipio",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Localidad Atención",
        value: "localidad_atencion",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      /*
      {
        text: "CURP",
        value: "curp",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Copia Póliza Seguro Popular",
        value: "seguro_popular",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "No. Póliza Seguro Popular",
        value: "num_poliza",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Celular o teléfono de contacto",
        value: "telefono",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      {
        text: "Correo electrónico",
        value: "email",
        align: "center",
        width: "6.25%",
        sortable: false,
      },
      */
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "6.25%",
        sortable: false,
      }
    ],
    editedItem: {
      id_paciente: -1,
      id_domicilio: -1,
      domicilio: "",
      id_localidad: -1,
      localidad: "",
      id_municipio: -1,
      municipio: "",
      folio: "",
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      fecha_nacimiento: "",
      edad: "",
      genero: false,
      curp: null,
      seguro_popular: false,
      num_poliza: null,
      telefono: null,
      email: null
    },
    defaultEditedItem: {
      id_paciente: -1,
      id_domicilio: -1,
      domicilio: "",
      id_localidad: -1,
      localidad: "",
      id_municipio: -1,
      municipio: "",
      folio: "",
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      fecha_nacimiento: "",
      edad: "",
      genero: false,
      curp: null,
      seguro_popular: false,
      num_poliza: null,
      telefono: null,
      email: null
    },
    loadingSave: false,
    errores:{
      nombre: false
    },
    defaultErrores: {
      nombre: false
    },
    dialogDelete: false,
    loadingDelete: false,
    nombreSearch: '',
    apellidoPaternoSearch: '',
    apellidoMaternoSearch: '',
    folioSearch: '',
    rangoSearch: null,
    dialogExpediente: false,
    pacienteItem: {
      id_paciente: -1,
      id_domicilio: -1,
      domicilio: "",
      id_localidad: -1,
      localidad: "",
      id_municipio: -1,
      municipio: "",
      folio: "",
      nombre: "",
      apellido_paterno: "",
      apellido_materno: "",
      fecha_nacimiento: "",
      edad: "",
      genero: false,
      curp: null,
      seguro_popular: false,
      num_poliza: null,
      telefono: null,
      email: null
    },
    loadingEstados: false,
    estados: [],
    historicoItem: {
      id_estado: null,
      archivo: null,
    },
    defaultHistoricoItem: {
      id_estado: null,
      archivo: null,
    },
    loadingMasive: false,
    dialogHistorico: false,
    dialogArchivoErrores: false,
    archivoErrores: null,
    loadingServicios: false,
    servicios: [],
    servicioSearch: null,
  }),
  mounted() {
    this.getItems();
    this.getEstados();
    this.getServicios();
  },
  methods: {
    getEstados(){
      this.loadingEstados = true;
      axios
        .get('/Catalogos/ListarEstados')
        .then(response => {
          this.estados = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingEstados = false;
        })
    },
    getServicios(){
      this.loadingServicios = true;
      axios
      .get('/Catalogos/ListarServicios')
      .then(response => {
        this.servicios = response.data;
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingServicios = false;
      })
    },
    onItemsPerPageChange(value){
      this.page = 1;
      this.itemsPerPage = value;
      this.getItems();
    },
    getItems(){
      const url = new URL(`http://localhost/Pacientes/ListarPacientes`);
      if(this.nombreSearch != null && this.nombreSearch.length > 0) url.searchParams.append("nombre", this.nombreSearch);
      if(this.apellidoPaternoSearch != null && this.apellidoPaternoSearch.length > 0) url.searchParams.append("apellido_paterno", this.apellidoPaternoSearch);
      if(this.apellidoMaternoSearch != null && this.apellidoMaternoSearch.length > 0) url.searchParams.append("apellido_materno", this.apellidoMaternoSearch);
      if(this.folioSearch != null && this.folioSearch.length > 0) url.searchParams.append("folio", this.folioSearch);
      if(this.rangoSearch != null && this.rangoSearch.length == 2) {
        if(this.rangoSearch[0] != null) url.searchParams.append("desde", this.rangoSearch[0]);
        if(this.rangoSearch[1] != null) url.searchParams.append("hasta", this.rangoSearch[1]);
      }
      if(this.servicioSearch != null) url.searchParams.append("id_servicio", this.servicioSearch);
      
      url.searchParams.append("page", this.page);
      url.searchParams.append("size", this.itemsPerPage);

      var url_string = url.href.replace('http://localhost', '');

      this.loading = true;
      axios
        .get(url_string)
        .then(response => {
          this.items = response.data.results;
          this.totalRecords = response.data.total_records;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    openDialogAddEdit(editItem = null){
      if(editItem != null) this.editedItem = Object.assign({}, editItem);
      else this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.errores = Object.assign({}, this.defaultErrores);
      this.dialogAddEdit = true;
    },
    closeDialogAddEdit(){
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.errores = Object.assign({}, this.defaultErrores);
      this.dialogAddEdit = false;
    },
    saveDialogAddEdit(){
      this.errores = Object.assign({}, this.defaultErrores);

      if (this.editedItem.nombre.length === 0 || this.editedItem.nombre.length > 256) {
        this.errores.nombre = true;
        return;
      }

      this.loadingSave = true;

      axios({
        method: this.editedItem.id_paciente === -1 ? 'POST' : 'PUT',
        url: this.editedItem.id_paciente === -1 ? '/Pacientes/CrearPaciente' : `/Pacientes/EditarPaciente/${this.editedItem.id_paciente}`,
        data: {
          nombre: this.editedItem.nombre
        }
      })
      .then(() => {
        this.getItems();
        this.closeDialogAddEdit();
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        this.loadingSave = false;
      });
    },
    openDialogDelete(editItem){
      this.editedItem = Object.assign({}, editItem);
      this.dialogDelete = true;
    },
    closeDialogDelete(){
      this.editedItem = Object.assign({}, this.defaultEditedItem);
      this.dialogDelete = false;
    },
    saveDialogDelete(){
      this.loadingDelete = true;
      axios
        .delete(`/Pacientes/EliminarPaciente/${this.editedItem.id_paciente}`)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    },
    openDialogExpediente(item){
      this.$refs.expediente.openDialog(item.id_paciente);
    },
    debouncedSearchInput: _.debounce(function() {
      this.page = 1;
      this.getItems();
    }, 1000),
  },
  watch: {
    nombreSearch: function() {
      this.debouncedSearchInput();
    },
    apellidoPaternoSearch: function() {
      this.debouncedSearchInput();
    },
    apellidoMaternoSearch: function() {
      this.debouncedSearchInput();
    },
    folioSearch: function() {
      this.debouncedSearchInput();
    },
    rangoSearch: function() {
      this.debouncedSearchInput();
    },
    servicioSearch: function() {
      this.debouncedSearchInput();
    },
  },
}
</script>